import React, { useCallback, useEffect, useState } from "react";
import { Modal, notification } from "antd";
import { useSelector } from "react-redux";
import { getIsBillingFrozen } from "../../selectors/selectors";
import { useBillingStripe } from "../../Hooks/billingStripe";
import { registerBillingFrozenPaywall } from "../../utils/billingFreezePaywall";
import BillingPausedPaywall from "../BillingPausedPaywall/BillingPausedPaywall";

/**
 * Mount once under the router. Registers the paywall bus for entry guards + axios.
 * @returns {React.ReactElement}
 */
const BillingFrozenGateHost: React.FC = () => {
  const isBillingFrozen = useSelector(getIsBillingFrozen);
  const openCustomerPortal = useBillingStripe();
  const [open, setOpen] = useState(false);
  const [opening, setOpening] = useState(false);

  const showPaywall = useCallback(() => {
    setOpen(true);
  }, []);

  useEffect(() => {
    return registerBillingFrozenPaywall({
      isFrozen: () => Boolean(isBillingFrozen),
      open: showPaywall,
    });
  }, [isBillingFrozen, showPaywall]);

  const handlePayOutstanding = async () => {
    setOpening(true);
    const billingTab = window.open("about:blank", "_blank");
    try {
      const response = await openCustomerPortal();
      const url = response?.url || response?.data?.url;
      if (url && billingTab) {
        billingTab.location.href = url;
        return;
      }
      if (url) {
        window.open(url, "_blank", "noopener,noreferrer");
        return;
      }
      billingTab?.close();
      notification.error({
        message: "Unable to open billing",
        description: "No Stripe billing URL was returned. Please try again.",
      });
    } catch {
      billingTab?.close();
      notification.error({
        message: "Unable to open billing",
        description:
          "Could not open Stripe Customer Portal to pay outstanding invoices.",
      });
    } finally {
      setOpening(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      centered
      destroyOnClose
      width={520}
      title={null}
    >
      <BillingPausedPaywall
        opening={opening}
        onPayOutstanding={handlePayOutstanding}
      />
    </Modal>
  );
};

export default BillingFrozenGateHost;
